import { Button, Dropdown, type MenuProps } from "antd";
import { BiEdit } from "react-icons/bi";
import { BsTrash } from "react-icons/bs";
import { CgScreen } from "react-icons/cg";
import { HiOutlineDotsHorizontal } from "react-icons/hi";

export const TableMenuDropdown = ({
  onClick,
}: {
  onClick: (key: string) => void;
}) => {
  const items: MenuProps["items"] = [
    {
      key: "show",
      label: "Show",
      icon: <CgScreen size={17} />,
    },
    {
      key: "edit",
      label: "Edit",
      icon: <BiEdit size={17} />,
    },
    {
      key: "delete",
      label: "Delete",
      icon: <BsTrash size={17} />,
    },
  ];

  const handleMenuClick: MenuProps["onClick"] = async ({ key }) => {
    onClick(key);
  };

  return (
    <Dropdown
      menu={{ items, onClick: handleMenuClick }}
      trigger={["hover"]}
      placement="bottomRight"
      arrow
    >
      <Button type="text" icon={<HiOutlineDotsHorizontal />} />
    </Dropdown>
  );
};
